<template>
  <div>
    <b-row>
      <b-col>
        <h6>Select Entity</h6>
        <v-select
          v-model="panelconfig.dataSources[0]"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="name"
          :reduce="dataSourceType => dataSourceType.value"
          :options="entities"
        />
        <div>
          <label for="tags-basic">Type a new tag and press enter</label>
          <b-form-tags
            v-model="panelconfig.fields"
            input-id="tags-basic"
            class="mb-2"
            @input="updatePanelConfigFields"
          />
        </div>

      </b-col>
      <!-- add more fields -->
    </b-row>

    <b-row>
      <b-col>
        <button
          class="btn btn-primary"
          @click="panelconfig.fields.push('')"
        >
          Add Field
        </button>

      </b-col>
    </b-row>

    <b-row class="justify-content-md-center border-bottom border-top mb-2 mt-2 pt-2">
      <b-col lg="8">
        <Table
          :panelconfig="panelconfig"
          @update-panelconfig-fields="updatePanelConfigFields"
        />
      </b-col>
    </b-row>

    <b-form
      v-if="panelconfig.dataSources.length > 0"
      @submit.prevent
    >

      <b-col class="border-bottom" />

    </b-form>
    <kbd>
      {{ panelconfig }}
    </kbd>
  </div>

</template>

<script>
import {
  BCol,
  BRow,
  BForm,
  BFormTags,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Table from './Table.vue'

export default {
  components: {
    BCol,
    BForm,
    BRow,
    Table,
    vSelect,
    BFormTags,
  },
  props: {
    panelconfig: {
      type: Object,
      default: () => ({
        dataSources: [],
        fields: [],
        icon: {
          title: '',
          id: '',
        },
        color: '',
        hover: false,
      }),
    },
  },
  data() {
    return {
      fields: [],
      entities: [
        { name: 'Device', value: 'device' },
        { name: 'Object', value: 'object' },
        { name: 'Sites', value: 'site' },
      ],
    }
  },
  methods: {
    updatePanelConfigFields(newFields) {
      // console.log('newFields', newFields)
      this.panelconfig.fields = newFields
    },
  },
}
</script>

  <style lang="scss">
  .hover {
    background-color: rgba(45, 177, 85, 0.153); /* Black background with opacity */
    z-index: 0; /* Specify a stack order in case you're using a different order for other elements */
    cursor: pointer; /* Add a pointer on hover */
  }
  .highlight{
     background-color: rgba(45, 177, 85, 0.594);
  }
  </style>
